// @ts-nocheck
import type { CartDiscountsV2PromotionTypeEnum } from '@redteclab/api/clients/bully'
import { type FC, useState } from 'react'

import { OFFER_PROMOTION_TYPES } from 'shared/consts/marketplace/promotion'
import {
  CartControllerCartShippingDetailV2,
  type CartControllerGroupEntryV2,
} from 'types/api/cart'
import { type PublicRuntimeConfig } from 'types/shopConfig'
import ProductItemWrapper from 'views/components/organisms/ProductItemWrapper'
import withShopAndRuntimeConfig from 'views/enhancers/withShopAndRuntimeConfig'

import ProductItemContent from './ProductItemContent'

import './ProductListing.scss'

export interface ProductListingProps {
  products: CartControllerGroupEntryV2[]
  currency: string
  productType: string
  sellerId: string
  disabledSelect?: boolean
  showAdditionalInformation?: boolean
  isFreebie?: boolean
  isERx: boolean
  hasOverdraft: boolean
  hasOverdraftMaxed: boolean
  publicRuntimeConfig: PublicRuntimeConfig
  promotions?: Record<CartDiscountsV2PromotionTypeEnum, string[]>
  sellerPromotion: SellerPromotionV2
  cartShippingDetail?: CartControllerCartShippingDetailV2
}

const ProductListing: FC<ProductListingProps> = ({
  sellerId,
  productType,
  isERx,
  products,
  currency,
  disabledSelect = false,
  isFreebie = false,
  showAdditionalInformation = false,
  publicRuntimeConfig: {
    publicConfig: { discountBoundaries, deviceClass },
  },
  hasOverdraft = false,
  hasOverdraftMaxed = false,
  promotions,
  sellerPromotion,
  cartShippingDetail,
}) => {
  const [greyedOut, setGreyedOut] = useState([])

  return (
    <div className="l-grid">
      <div className="l-grid__item">
        <ul className="a-list-reset">
          {products.map((product, idx) => {
            const evaluatedProductType = isERx
              ? product.prescriptionType
              : productType

            return (
              <ProductItemWrapper
                rowNumber={idx}
                productQuantity={product.quantity}
                {...(!!product.promotion &&
                !!product.promotion.promotionOfferPostfix
                  ? {
                      ...product,
                      productName: `${product.productName} ${product.promotion.promotionOfferPostfix}`,
                    }
                  : product)}
                key={`${sellerId}-${product.hashedToken}-${sellerId}-${product.offerId}-${product.productId}`}
                rightColumnAlign="top"
                nowProduct={product?.nowItemData?.nowProduct}
                border={Boolean(idx + 1 < products?.length || 0)}
                currency={currency}
                isFreebie={isFreebie}
                additionalInformation={
                  showAdditionalInformation
                    ? OFFER_PROMOTION_TYPES.FREEBIE
                    : null
                }
                unitPricing={isFreebie ? null : product.unitPricing}
                renderAvailability={!isFreebie}
                productType={evaluatedProductType}
                isERx={isERx}
                priceLabelInfo={product.priceLabelInfo}
                redPointsMultiplier={product.redPointsMultiplier}
                isDeleting={greyedOut.includes(product.offerId)}
                substitutionStatus={product.substitutionStatus}
                originalPrescriptionPzn={product.originalPrescriptionPzn}
                originalPrescriptionProduct={
                  product.originalPrescriptionProduct
                }
                canonicalUrl={product.canonicalUrl}
                cartShippingDetail={cartShippingDetail}
                volumePricing={product.volumeBasedPrices}
                sellerId={sellerId}
                offerId={product.offerId}
                sellerPromotion={
                  sellerPromotion?.offerId === product.offerId
                    ? sellerPromotion
                    : null
                }
              >
                <ProductItemContent
                  product={product}
                  isERx={isERx}
                  isFreebie={isFreebie}
                  deviceClass={deviceClass}
                  disabledSelect={disabledSelect}
                  hasOverdraft={hasOverdraft}
                  hasOverdraftMaxed={hasOverdraftMaxed}
                  evaluatedProductType={evaluatedProductType}
                  setGreyedOut={setGreyedOut}
                  discountBoundaries={discountBoundaries}
                  currency={currency}
                  promotions={promotions}
                />
              </ProductItemWrapper>
            )
          })}
        </ul>
      </div>
    </div>
  )
}

export default withShopAndRuntimeConfig(ProductListing)
